import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const GenderAutocomplete = ({ value, handleChange, stateName = null }) => {
  return (
    <Autocomplete
      id="dmv-gender-autocomplete"
      autoSelect
      autoHighlight
      options={["", "M", "F", "U"]}
      style={{ width: 300 }}
      onChange={(_, newValue) => {
        handleChange({
          target: { name: stateName || "gender", value: newValue },
        });
      }}
      name="gender"
      value={value}
      label="Gender"
      renderInput={params => (
        <TextField {...params} label="Gender (M, F, U)" variant="outlined" />
      )}
    />
  );
};

export default GenderAutocomplete;
